// Dependencias generales
import React from "react";
import { useEffect } from 'react';

import Action from './Action'


// DASHBOARD
const ActionList = (params) => {
  
  useEffect(() => {   
    console.log("Listado de condiciones cargado correctamente.")
  },[params]);

  const listActions = params.objRule.Rule.actions.map((action, index) =>

  <React.Fragment key={index}>

    <Action      
      ruleInfo={params.objRule}    
      actionInfo={action} 
      objDatosDashboard={params.objDatosDashboard} 
      objDatosDispositivos={params.objDatosDispositivos} 
      eliminarAccion={params.eliminarAccion}
      mostrarOcultarBloqueResumen={params.mostrarOcultarBloqueResumen}      
      visibilidadModalFiltradoDatos={params.visibilidadModalFiltradoDatos}
      setObjRuleElementSelector={params.setObjRuleElementSelector}
    /> 

  </React.Fragment>
  );    


  return (        
    <>{listActions}</>
  )
}

export default ActionList